import React from "react"
import PropTypes from 'prop-types'
import { Route, Redirect } from "react-router-dom"
import getAccessRights from "components/Common/getAccessRights"

const AppRoute = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      if (isAuthProtected && !localStorage.getItem("authUser")) {
        return (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        )
      }

      // if (isAuthProtected) {
      //   const hasAccess = getAccessRights(props.location.pathname);
      //   if (!hasAccess) {
      //     return <Redirect to="/unAuthorized" />;
      //   }
      // }

      return (
        <Layout>
          <Component {...props} />
        </Layout>
      )
    }}
  />
)

AppRoute.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any
}

export default AppRoute
